module.exports = __webpack_public_path__ + "static/media/button-uhr.b2435587.svg";